import React from "react";
import Breadcrumb from "../../../components/Breadcrumb";
import { SMS_CREDIT_REQUEST } from "../../../Routing/routes";
import SmsCreditRequestListLayer from "./Component/SmsCreditRequestListLayer";

const SmsCreditRequest = () => {
    const links = [{ to: SMS_CREDIT_REQUEST, text: 'SMS Credit Request' }];

    return (
        <>
            <Breadcrumb
                replaceClass="mb-24"
                description='View and manage SMS credit requests from societies'
                links={links}
                headingTitle="SMS Credit Request"
            />
            <SmsCreditRequestListLayer />
        </>
    );
};

export default SmsCreditRequest;
